import { Divider, Heading, Icon, Text, VStack } from "@chakra-ui/react";
import HoverableIconButton from "components/Atomos/Buttons/HoverableIconButton";
import { FiEye } from "react-icons/fi";

type ComplaintPopupProps = {
    title: string;
    complaintType: string;
    hideButtons?: boolean;
    onViewClick?: () => void | Promise<void>;
}

const ComplaintPopup = ({
    title,
    complaintType,
    hideButtons,
    onViewClick
}: ComplaintPopupProps) => {
    return (
        <VStack p={2} justify="flex-start" align="flex-start">
            <Heading>Manifestação</Heading>
            <Text color="gray.300">{title}</Text>
            <Divider my={1} />
            <Text color="gray.300">Tipo: {complaintType}</Text>
            {!hideButtons && (
                <HoverableIconButton
                    colorScheme="blue"
                    icon={<Icon as={FiEye} />}
                    label="Visualizar"
                    onClick={onViewClick}
                />
            )}
        </VStack>
    )
}
export default ComplaintPopup